import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import ContactActivity from "./ContactActivity";

interface ContactActivitySheetProps {
  contactId: string | null;
  onOpenChange: (open: boolean) => void;
}

const ContactActivitySheet: React.FC<ContactActivitySheetProps> = ({ contactId, onOpenChange }) => (
  <Sheet open={!!contactId} onOpenChange={onOpenChange}>
    <SheetContent className="flex w-full flex-col gap-0 p-0 sm:max-w-md">
      <SheetHeader className="border-b px-4 py-3 text-left">
        <SheetTitle className="text-base">Contact activity</SheetTitle>
      </SheetHeader>
      <div className="flex-1 overflow-y-auto">
        {contactId && <ContactActivity contactId={contactId} compact />}
      </div>
    </SheetContent>
  </Sheet>
);

export default ContactActivitySheet;
